import { memo, useRef } from 'react'

import { scrollToElementById } from 'utils'

import * as Styled from './styled'
import Version from './version'
import { useSelector } from 'react-redux'
import { editorThunks } from 'store/features/editor/thunks'
import { editorSelectors } from 'store/features/editor/selectors'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useResponsive } from 'hooks/useResponsive'
import { useSelectedLibSoundVersionsSelectorState } from '../../hooks'
import useAudioLimitCheck from 'hooks/useAudioLimitCheck'

const MusicVersioningVersions = () => {
  const { selectedLibSoundVersions } =
    useSelectedLibSoundVersionsSelectorState()

  const selectedAudioDuration = useSelector(
    projectDataSelectors.activeAudioDuration
  )
  const selectedAudioId = useSelector(editorSelectors.activeTimelineItemId)
  const activeAudio = useSelector(projectDataSelectors.activeAudio)

  const currentPlayingAudioRef = useRef(null)
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const { isAudioDurationAllowed } = useAudioLimitCheck()

  return (
    <Styled.MusicVersioningVersionsContainer>
      {selectedLibSoundVersions.map(version => {
        return (
          <Version
            key={version.id}
            version={version}
            isSelected={version.duration === selectedAudioDuration}
            onClick={() => {
              if (
                !isAudioDurationAllowed(version.duration, {
                  checkLineOnly: true,
                  lineIndex: activeAudio?.lineIndex ?? 0
                })
              ) {
                return
              }
              dispatch(projectDataThunks.updateSoundVersion(version))

              if (selectedAudioId) {
                scrollToElementById(selectedAudioId)
              }

              if (isMobile) {
                dispatch(editorThunks.setIsMobileSubSidebarOpen(false))
              }
            }}
            currentPlayingAudioRef={currentPlayingAudioRef}
          />
        )
      })}
    </Styled.MusicVersioningVersionsContainer>
  )
}

export default memo(MusicVersioningVersions)
